import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  specializedServices : [],
  subServices : [],
  subServiceData : [],
  createSubServicesData : null,
  specializedServiceData : null,
  error : null
};


export const SPECIALIZED_SERVICES = "admin/specialized/services";
export const SUB_SERVICES = "admin/specialized/subservices";
export const SUB_SERVICE_BY_ID = "admin/subservice";
export const CREATE_SUB_SERVICES = "admin/store/subservice";
export const CREATE_SPECIALIZED_SERVICES = "admin/store/specializedservice";

export const getSpecializedServices = createAsyncThunk(
    SPECIALIZED_SERVICES,
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.get(SPECIALIZED_SERVICES, {
          params : formData
        });
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const getSubServices = createAsyncThunk(
    SUB_SERVICES,
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        let id = formData.id
        const response = await axiosInstance.get(SUB_SERVICES + '/' + id, {
          params : formData
        });
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        console.log(error)
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const getSubServiceById = createAsyncThunk(
  SUB_SERVICE_BY_ID,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      let id = formData.id
      const response = await axiosInstance.get(SUB_SERVICE_BY_ID + '/' + id);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      console.log(error)
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const createSpecializedService = createAsyncThunk(
  CREATE_SPECIALIZED_SERVICES,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(CREATE_SPECIALIZED_SERVICES, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      console.log(error)
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const createSubServices = createAsyncThunk(
  CREATE_SUB_SERVICES,
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.post(CREATE_SUB_SERVICES, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      console.log(error)
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

const servicesSlice = createSlice({
    name: "services",
    initialState,
    extraReducers: (builder) => {
      builder
        .addCase(getSpecializedServices.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(getSpecializedServices.fulfilled, (state, action) => {
          state.isLoading = false;
          state.specializedServices = action.payload;
        })
        .addCase(getSpecializedServices.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })
        .addCase(getSubServices.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(getSubServices.fulfilled, (state, action) => {
            state.isLoading = false;
            state.subServices = action.payload;
        })
        .addCase(getSubServices.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(createSubServices.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(createSubServices.fulfilled, (state, action) => {
            state.isLoading = false;
            state.createSubServicesData = action.payload;
        })
        .addCase(createSubServices.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(getSubServiceById.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(getSubServiceById.fulfilled, (state, action) => {
            state.isLoading = false;
            state.subServiceData = action.payload;
        })
        .addCase(getSubServiceById.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(createSpecializedService.pending, (state) => {
          state.isLoading = true;
          state.error = null;
        })
        .addCase(createSpecializedService.fulfilled, (state, action) => {
            state.isLoading = false;
            state.specializedServiceData = action.payload;
        })
        .addCase(createSpecializedService.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(logout, () => initialState);
    },
});
  
export default servicesSlice.reducer;